import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { JSX } from 'react';

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const { isAuthenticated, loading, saveRedirect } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FC]">
        <div className="text-sm text-slate-400">正在检查登录状态...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    saveRedirect(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return children;
};

export default RequireAuth;
